var _rect, _path, _g, _path2, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventoryManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1e88e5",
    height: 52,
    rx: 4,
    width: 42,
    x: 4,
    y: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 17h44v34h-44z",
    fill: "#eceff1",
    transform: "matrix(0 1 -1 0 59 9)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#cfd8dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36 21.75h-22c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h22c.4141 0 .75.3359.75.75s-.3359.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 28.75h-22c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h22c.4141 0 .75.3359.75.75s-.3359.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 35.75h-22c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h22c.4141 0 .75.3359.75.75s-.3359.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 42.75h-22c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h22c.4141 0 .75.3359.75.75s-.3359.75-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 49.75h-22c-.4141 0-.75-.3359-.75-.75s.3359-.75.75-.75h22c.4141 0 .75.3359.75.75s-.3359.75-.75.75z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m29 8c0-2.2092-1.7908-4-4-4s-4 1.7908-4 4h-5v4c0 1.1046.8954 2 2 2h14c1.1046 0 2-.8954 2-2v-4z",
    fill: "#37474f"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffa000",
    height: 16,
    rx: 2,
    width: 18,
    x: 33,
    y: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 28h6v5c0 .5519-.4481 1-1 1h-4c-.5519 0-1-.4481-1-1z",
    fill: "#ff8f00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ff8f00",
    height: 16,
    rx: 2,
    width: 18,
    x: 42,
    y: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 44h6v5c0 .5519-.4481 1-1 1h-4c-.5519 0-1-.4481-1-1z",
    fill: "#ff6f00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#ffb300",
    height: 16,
    rx: 2,
    width: 18,
    x: 24,
    y: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 44h6v5c0 .5519-.4481 1-1 1h-4c-.5519 0-1-.4481-1-1z",
    fill: "#ffa000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryManagement);
export default __webpack_public_path__ + "static/media/inventory-management.cf4b534b450b30614d787214362b908a.svg";
export { ForwardRef as ReactComponent };